export class Question {
  static fromItem(item) {
    return new Question(item.question);
  }
  constructor(value) {
    this.value = value;
  }
  toString() {
    return this.value;
  }
}